import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { KorisniciModule } from './pages/sifarnici/korisnici/korisnici.module';
import { RtsAuthService } from './services/rtsAuth.service';
import { DummyService } from './services/dummy.service';
import { DummySettingsService } from './services/dummy-settings.service';
import { BackendService } from './services/backend.service';
import { UtilServiceClient } from './services/util.service';
import { ExportService } from './services/export.service';
import { MediaPlanService } from './services/media-plan.service';
import { FontService } from './fonts/font.service';
import { MontazaService } from './services/montaza.service';
import { ValidationService } from './services/validation.service';
import { RasporedService } from './services/raspored.service';
import { IzvestajSettings } from './pages/izvestaji/prihodi-po-emisijama/izvestaj-settings.service';
import { ReportService } from './services/report.service';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { IzvestajToolbarComponent } from './components/izvestaj-toolbar/izvestaj-toolbar.component';
import { RezervacijeModule } from './pages/rezervacije/rezervacije.module';

import { AppRoutingModule } from './app-routing.module';
import { PagesModule } from './pages/pages.module';
import { AuthGuard } from './guards/auth.guard';
import { ProfileModule } from 'beyond-util';
import { CenovniciModule } from './pages/sifarnici/cenovnici/cenovnici.module';
import { CiljneGrupeModule } from './pages/sifarnici/ciljne-grupe/ciljne-grupe.module';
import { PrihodiPoEmisijamaModule } from './pages/izvestaji/prihodi-po-emisijama/prihodi-po-emisijama.module';
import { VrstaZabraneModule } from './pages/sifarnici/vrsta-zabrane/vrsta-zabrane.module';
import { SpotoviModule } from './pages/sifarnici/spotovi/spotovi.module';
import { OdrzavanjeProgramaModule } from './pages/sifarnici/odrzavanje-programa/odrzavanje-programa.module';
import { PopustiUvecanjaModule } from './pages/sifarnici/popusti-uvecanja/popusti-uvecanja.module';
import { PregledKupacaModule } from './pages/sifarnici/pregled-kupaca/pregled-kupaca.module';
import { EmisijeModule } from './pages/sifarnici/emisije/emisije.module';
import { UgovoriModule } from './pages/sifarnici/ugovori/ugovori.module';
import { MediaPlanModule } from './pages/media-plan/media-plan.module';
import { HttpClientModule } from '@angular/common/http';
import { KurseviModule } from './pages/sifarnici/kursevi/kursevi.module';
import { BankeModule } from './pages/sifarnici/banke/banke.module';
import { BrendoviModule } from './pages/sifarnici/brendovi/brendovi.module';
import { OdlukeModule } from './pages/sifarnici/odluke/odluke.module';
import { NacinObracunaModule } from './pages/sifarnici/nacin-obracuna/nacin-obracuna.module';
import { NacinPlacanjaModule } from './pages/sifarnici/nacin-placanja/nacin-placanja.module';
import { MontazaModule } from './pages/montaza/montaza.module';
import { IzvestajOPopunjenostiReklamnihBlokovaModule } from './pages/izvestaji/izvestaj-o-popunjenosti-reklamnih-blokova/izvestaj-o-popunjenosti-reklamnih-blokova.module';
import { DnevniPlanEmitovanjaModule } from './pages/izvestaji/dnevni-plan-emitovanja/dnevni-plan-emitovanja.module';
import { EnumService } from './services/enum.service';
import { VerifikacijaModule } from './pages/verifikacija/verifikacija.module';
import { PregledObracunaModule } from './pages/pregled-obracuna/pregled-obracuna.module';
import { VrsteSpotaModule } from './pages/sifarnici/vrste-spota/vrste-spota.module';
import { MedijumiModule } from './pages/sifarnici/medijumi/medijumi.module';
import { FakturisanjeModule } from './pages/fakturisanje/fakturisanje.module';
import { authInterceptorProviders } from './guards/auth.interceptor';
import { TipoviKorekcijaModule } from './pages/sifarnici/tipovi-korekcija/tipovi-korekcija.module';
import { VideoUputstvaModule } from './pages/video-uputstva/video-uputstva.module';
import { VideoUputstvaService } from './services/video-uputstva.service';
import { KopijaVerifikacijeModule } from './pages/kopija-verifikacije/kopija-verifikacije.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule } from 'angular-calendar';
import { SpotoviService } from './services/spotovi.service';
import { RealizacijaUgovoraModule } from './pages/izvestaji/realizacija-ugovora/realizacija-ugovora.module';
import { BudzetService } from './services/budzet.service';
import { PregledFakturaModule } from './pages/pregled-faktura/pregled-faktura.module';
import { PregledSpecifikacijaModule } from './pages/pregled-specifikacija/pregled-specifikacija.module';
import { EmisijaCenaService } from './components/emisija-cena-details/emisija-cena.service';
import { AriannaModule } from './pages/arianna/arianna.module';
import { AriannaNekonsolidovaniModule } from './pages/arianna-nekonsolidovani/arianna-nekonsolidovani.module';
import { registerLocaleData } from '@angular/common';
import localeSr from '@angular/common/locales/sr-Latn';
import { IzvestajZaSokojModule } from './pages/izvestaji/izvestaj-za-sokoj/izvestaj-za-sokoj.module';
import { IzvestajZaOfpsModule } from './pages/izvestaji/izvestaj-za-ofps/izvestaj-za-ofps.module';
import { GlinkMaska16Module } from './pages/izvestaji/glink-maska-16/glink-maska-16.module';
import { IzvestajRealizacijeModule } from './pages/izvestaji/izvestaj-realizacije/izvestaj-realizacije.module';
import { IzvestajZaPgpIMuzickuProdukcijuModule } from './pages/izvestaji/izvestaj-za-pgp-i-muzicku-produkciju/izvestaj-za-pgp-i-muzicku-produkciju.module';
import { PregledUgovoraZaObracunComponent } from './pages/pregled-ugovora-za-obracun/pregled-ugovora-za-obracun.component';
import { PregledUgovoraZaObracunModule } from './pages/pregled-ugovora-za-obracun/pregled-ugovora-za-obracun.module';
import { AriannaGledanostEmisijeModule } from './pages/arianna-gledanost-emisije/arianna-gledanost-emisije.module';
import { NepriznataEmitovanjaModule } from './pages/nepriznata-emitovanja/nepriznata-emitovanja.module';
import { MontazaKalendarModule } from './components/montaza/montaza-kalendar/montaza-kalendar.module';
import { PregledAvansaModule } from './pages/pregled-avansa/pregled-avansa.module';
import { PregledVerifikacijeComponent } from './pages/pregled-verifikacije/pregled-verifikacije.component';
import { PregledVerifikacijeModule } from './pages/pregled-verifikacije/pregled-verifikacije.module';
import { IzvestajPrihodaPoEmisijamaModule } from './pages/izvestaji/izvestaj-prihoda-po-emisijama/izvestaj-prihoda-po-emisijama.module';
import { ZeljenePozicijeModule } from './pages/zeljene-pozicije/zeljene-pozicije.module';

registerLocaleData(localeSr);

@NgModule({
  declarations: [AppComponent, LoginComponent, IzvestajToolbarComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    PagesModule,
    ReactiveFormsModule,
    KorisniciModule,
    PrihodiPoEmisijamaModule,
    RealizacijaUgovoraModule,
    CiljneGrupeModule,
    ProfileModule,
    CenovniciModule,
    VrstaZabraneModule,
    SpotoviModule,
    OdrzavanjeProgramaModule,
    PopustiUvecanjaModule,
    PregledKupacaModule,
    EmisijeModule,
    UgovoriModule,
    MediaPlanModule,
    HttpClientModule,
    KurseviModule,
    BankeModule,
    BrendoviModule,
    OdlukeModule,
    NacinObracunaModule,
    NacinPlacanjaModule,
    RezervacijeModule,
    ZeljenePozicijeModule,
    MontazaModule,
    IzvestajOPopunjenostiReklamnihBlokovaModule,
    DnevniPlanEmitovanjaModule,
    VerifikacijaModule,
    PregledObracunaModule,
    VrsteSpotaModule,
    MedijumiModule,
    FakturisanjeModule,
    TipoviKorekcijaModule,
    VideoUputstvaModule,
    KopijaVerifikacijeModule,
    BrowserAnimationsModule,
    // CalendarModule.forRoot(),
    PregledFakturaModule,
    PregledSpecifikacijaModule,
    AriannaModule,
    AriannaNekonsolidovaniModule,
    IzvestajZaSokojModule,
    IzvestajZaOfpsModule,
    GlinkMaska16Module,
    IzvestajRealizacijeModule,
    IzvestajZaPgpIMuzickuProdukcijuModule,
    PregledUgovoraZaObracunModule,
    AriannaGledanostEmisijeModule,
    NepriznataEmitovanjaModule,
    PregledAvansaModule,
    PregledVerifikacijeModule,
    IzvestajPrihodaPoEmisijamaModule,
  ],
  providers: [
    authInterceptorProviders,
    DummyService,
    RtsAuthService,
    AuthGuard,
    DummySettingsService,
    BackendService,
    UtilServiceClient,
    IzvestajSettings,
    ExportService,
    MediaPlanService,
    FontService,
    MontazaService,
    ValidationService,
    RasporedService,
    ReportService,
    EnumService,
    VideoUputstvaService,
    SpotoviService,
    BudzetService,
    EmisijaCenaService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts